<template>
    <div class="sidebar">
        <div class="sidebar-header semiopaque">

            <i class="fas fa-person-digging"></i>
            <i class="fas fa-person-digging" style="transform: scaleX(-1);"></i>
            <i></i>
            <a href="/" style="text-decoration: none; color: var(--text-primary)"><i class="fas fa-person-harassing" title="Работай!"></i></a>
            <i></i>
            <i class="fas fa-person-digging"></i>
            <i class="fas fa-person-digging" style="transform: scaleX(-1);"></i>

            <button class="btn-close sidebar-toggle" id="sidebarToggle">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="sidebar-menu fancy-scrollbar">
            <div v-for="link in links" :key="link.path" class="sidebar-menu-item">
                
                <router-link :to="link.path" v-if="!link.meta?.nolink" class="sidebar-menu-link">
                    <i :class="link.meta?.icon"></i> {{ link.meta?.label }}
                </router-link>
                <span v-else class="sidebar-menu-link">
                    <i :class="link.meta?.icon"></i> {{ link.meta?.label }}
                </span>

                <router-link v-for="sublink in link.meta?.sublinks" :key="sublink.path" :to="sublink.path" class="sidebar-submenu-link">
                    &nbsp;{{ sublink.meta?.label }}
                </router-link>
            </div>
        </div>

        <div class="sidebar-history fancy-scrollbar" v-if="state.showHistory && state.history.length">
            <ul>
                <li v-for="h in sortedHistoryByDate" :key="h.path">
                    <router-link :to="h.path">
                        - {{ h.label }}
                        <span v-if="Object.keys(h.params).length">({{ formatParams(h.params) }})</span>
                        <span v-if="h.hash">&nbsp;{{ h.hash }}</span>
                    </router-link>
                </li>
            </ul>
        </div>
        
        <div class="sidebar-footer">
            <i class="fas fa-person-digging" style="transform: scaleX(-1);"></i>&nbsp;
            {{ auth.getCurrentUserData()?.email.split('@')[0] || 'Guest' }}
        </div>
    </div>
    <div class="sidebar-overlay"></div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { appRoutes } from '@/router/routes.js';
import { useUserStorage, useAuth } from '@/modules/f8/hooks';

const router = useRouter();
const userStorage = useUserStorage();
const auth = useAuth();

const state = reactive({
    showHistory: userStorage.ref('cfgShowHistory', false),
    history: userStorage.ref('cfgHistory', []),
    historyLimit: userStorage.ref('cfgHistoryLimit', 10)
});

const links = appRoutes.filter(r => r.meta?.group == 'sidebar');


const addToHistory = (to) => {
    // Если маршрут уже есть в истории, удаляем его
    state.history = state.history.filter(h => h.sum !== computeHistoryId(to));

    // Добавление нового маршрута в историю
    state.history.push({
        path: to.fullPath,
        label: to.name || to.path,
        params: { ...to.params, ...to.query },
        hash: window.location.hash,
        sum: computeHistoryId(to)
    });

    
    // Ограничение длины истории
    if (state.history.length > state.historyLimit) {
        state.history = state.history.slice(-state.historyLimit);
    }
};

const computeHistoryId = (to) => {
    return `${to.fullPath}-${to.name}-${formatParams({ ...to.params, ...to.query })}-${window.location.hash}`
}

const formatParams = (params) => {
    return Object.entries(params)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
};

// Вычисляемое свойство для получения истории в обратном порядке
const sortedHistoryByDate = computed(() => {
    return [...state.history].reverse();
});

onMounted(() => {
    // Отслеживаем навигацию
    router.afterEach((to) => {
        addToHistory(to);
    });

    const buttons = document.querySelectorAll('.sidebar-toggle');
    if (buttons) {
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                document.querySelector('body').classList.toggle('sidebar-open');
            });
            button.f8EventToggleSidebar = true;
        });
    }

    // Close sidebar when clicking on overlay
    const overlay = document.querySelector('.sidebar-overlay')
    if (overlay) {
        overlay.addEventListener('click', () => {
            document.querySelector('body').classList.remove('sidebar-open');
        });
    }
    document.f8EventToggleSidebar = true;
})

onUnmounted(() => {
    const buttons = document.querySelectorAll('.sidebar-toggle');
    if (buttons) {
        buttons.forEach(button => {
            button.removeEventListener('click', () => {
                document.querySelector('body').classList.toggle('sidebar-open');
            });
            button.f8EventToggleSidebar = false;
        });
    }

    // if overlay has event listener
    if (document.f8EventToggleSidebar) {
        const overlay = document.querySelector('.sidebar-overlay')
        if (overlay) {
            overlay.removeEventListener('click', () => {
                document.querySelector('body').classList.remove('sidebar-open');
            });
            document.f8EventToggleSidebar = false;
        }
    }
})

</script>

<style lang="scss" scoped>
// .fas {
//     margin-right: 4px;
//     font-size: 16px;
// }


// .road {
//   position: relative;
//   height: var(--header-height);
//   overflow: hidden;
// }

// .car {
//   position: absolute;
//   top: 50%;
//   font-size: 18px;
//   transform: translate(-120%, -50%); /* старт левее контейнера */
//   animation: drive 5s linear infinite;
// }

// /* сегменты с разными кривыми ускорения */
// @keyframes drive {
//   0% {
//     transform: translate(-120%, -50%);
//     animation-timing-function: cubic-bezier(.25,.46,.45,.94); /* ease-out */
//   }
//   60% {
//     transform: translate(-120%, -50%); 
//     animation-timing-function: cubic-bezier(.45,0,.55,1); /* ease-in-out */
//   }
//   70% {
//     transform: translate(45%, -50%); 
//     animation-timing-function: cubic-bezier(.45,0,.55,1); /* ease-in-out */
//   }
//   80% {
//     transform: translate(55%, -50%); 
//     animation-timing-function: cubic-bezier(.55,.06,.68,.19); /* ease-in */
//   }
//   100% {
//     transform: translate(1000%, -50%); /* уводим за правый край */
//   }
// }

// /* уважение предпочтений пользователя */
// @media (prefers-reduced-motion: reduce) {
//   .car { animation: none; transform: translate(0, -50%); }
// }

</style>